"use strict";

exports.__esModule = true;
exports.customStyleFn = exports.viewerCustomStyleFn = exports.styleSelectionPredicate = exports.getTextColorSchema = void 0;

var _lodash = require("lodash");

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var _colors = require("../../services/colors");

var _wixParams = require("../../constants/wix-params");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getTextColorSchema = function getTextColorSchema(appSettings) {
  if (appSettings === void 0) {
    appSettings = {};
  }

  var colors = [(0, _colors.getSiteColor)(appSettings, {
    wixParam: _wixParams.POST_TEXT_COLOR,
    presetFallback: 'color-5',
    colorFallback: '#00000'
  }), (0, _colors.getSiteColor)(appSettings, {
    wixParam: _wixParams.POST_TITLE_COLOR,
    presetFallback: 'color-5',
    colorFallback: '#00000'
  }), (0, _colors.getSiteColor)(appSettings, {
    wixParam: _wixParams.LINK_AND_HASHTAG_COLOR,
    presetFallback: 'color-8',
    colorFallback: '#00000'
  }), (0, _colors.getPresetColor)(appSettings, 'color-13'), (0, _colors.getPresetColor)(appSettings, 'color-18'), (0, _colors.getPresetColor)(appSettings, 'color-23')];
  return (0, _lodash.reduce)(colors, function (schema, color, index) {
    schema["textColor" + index] = {
      color: toHexColor(color),
      index: index
    };
    return schema;
  }, {});
};

exports.getTextColorSchema = getTextColorSchema;

var toHexColor = function toHexColor(color) {
  return (0, _tinycolor["default"])(color).toHexString();
};

var styleSelectionPredicate = function styleSelectionPredicate(colorScheme, richContent) {
  return function (inlineStyle) {
    return colorScheme[inlineStyle] && richContent.isHexColor(colorScheme[inlineStyle].color) || richContent.isHexColor(inlineStyle);
  };
};

exports.styleSelectionPredicate = styleSelectionPredicate;

var viewerCustomStyleFn = function viewerCustomStyleFn(colorScheme, richContent) {
  return function (inlineStyle) {
    if (colorScheme[inlineStyle] && richContent.isHexColor(colorScheme[inlineStyle].color)) {
      return {
        color: colorScheme[inlineStyle].color
      };
    }

    if (richContent.isHexColor(inlineStyle)) {
      return {
        color: inlineStyle
      };
    }

    return {};
  };
};

exports.viewerCustomStyleFn = viewerCustomStyleFn;

var customStyleFn = function customStyleFn(viewerCustomStyleFn, richContent) {
  return function (inlineStyles) {
    return (0, _lodash.reduce)(inlineStyles.toArray(), function (styles, inlineStyle) {
      return _objectSpread({}, styles, {}, viewerCustomStyleFn(inlineStyle, richContent));
    }, {});
  };
};

exports.customStyleFn = customStyleFn;